<template>
   <MainLayout>
    <Hero />
    <AboutUs />
    <MontebitProducts />
    <WhyMontebit />
    <Contact /> 
  </MainLayout>
</template>

<script>
import MainLayout from "@/components/layout/MainLayout.vue";
import Hero from "@/components/templates/sections/Hero.vue";
import AboutUs from "@/components/templates/sections/AboutUs.vue";
import MontebitProducts from "@/components/templates/sections/MontebitProducts.vue"
import WhyMontebit from "@/components/templates/sections/WhyMontebit.vue";
import Contact from "@/components/templates/sections/Contact.vue";

export default {
  name: "Home",
  components: {
    MainLayout,
    Hero,
    AboutUs,
    MontebitProducts,
    WhyMontebit,
    Contact,
  },
};
</script>
